import {
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import { getRoutes } from "./routes";

export const routesFromElements = createRoutesFromElements(
  getRoutes({ lang: "en", store: null }),
);

export const router = createBrowserRouter(routesFromElements);
